module.exports = __webpack_public_path__ + "img/award-winner.29f047b2.svg";